<template>
  <div>
    <sip-agent :ontIndex="uniqueOnt"></sip-agent>
    <sip-user-addr :ontIndex="uniqueOnt"></sip-user-addr>
    <sip-user-info :ontIndex="uniqueOnt"></sip-user-info>
    <sip-digitmap :ontIndex="uniqueOnt"></sip-digitmap>
  </div>
</template>

<script>
import SipAgent from "@/views/ProfileUniqueSipAgent.vue"
import SipUserAddr from "@/views/ProfileUniqueSipUserAddr.vue"
import SipUserInfo from "@/views/ProfileUniqueSipUserInfo.vue"
import SipDigitmap from "@/views/ProfileUniqueSipDigitmap.vue"

export default {
  components: {
    SipAgent,
    SipUserAddr,
    SipUserInfo,
    SipDigitmap
  },
  props: ["uniqueOnt"],
  data() {
    return {}
  },
}
</script>

